const Input = ({ label, placeholder, startIcon = null, prefix = null, helper, value, onChange, type = 'text', required = false }) => {
    return (
        <div className="flex flex-col gap-2"> 
            <p className="font-medium text-sm md:text-[15px]">{label}{required && <span className="text-red-500">*</span>}</p>
            <div className="flex flex-col gap-1">
                <div className="w-full flex items-center relative">
                    {startIcon && (
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                            {startIcon}
                        </div>
                    )}
                    {prefix && (
                        <div className={`absolute inset-y-0 flex items-center pl-3 ${startIcon ? 'left-6' : 'left-0'}`}>
                            <span className="text-sm text-gray-500">{prefix}</span>
                        </div>
                    )}
                    <input
                        className={`w-full py-2 text-sm border border-blue-200 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${prefix && startIcon ? 'pl-[66px] pr-4' : prefix || startIcon ? 'pl-10 pr-4' : 'px-4'} md:text-[15px]`}
                        type={type}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                    />
                </div>
                <span className="text-[10px] text-gray-500 md:text-sm">{helper}</span>
            </div>
        </div>
    )
};

export default Input;